import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Editor, HANDLED, NOT_HANDLED } from 'medium-draft';
import customrenderer from '../../../components/MediumDraft/customrenderer';
import s from './LessonTextContent.scss';

/* eslint-disable react/require-default-props */
/**
 * react/require-default-props does not support default parameters
 * in function components wrapped with React.forwardRef.
 *
 * React recommends using default parameters instead of defaultProps
 * for function components, and defaultProps are being deprecated.
 *
 * References:
 * - https://react.dev/reference/react/Component#defaultprops
 * - https://github.com/jsx-eslint/eslint-plugin-react/issues/1261
 */
var LessonTextContent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var editorState = _ref.editorState,
    keyBinding = _ref.keyBinding,
    className = _ref.className,
    children = _ref.children,
    _ref$editorEnabled = _ref.editorEnabled,
    editorEnabled = _ref$editorEnabled === void 0 ? false : _ref$editorEnabled,
    _ref$onEditorChange = _ref.onEditorChange,
    onEditorChange = _ref$onEditorChange === void 0 ? _.noop : _ref$onEditorChange,
    _ref$handleKeyCommand = _ref.handleKeyCommand,
    handleKeyCommand = _ref$handleKeyCommand === void 0 ? function () {
      return false;
    } : _ref$handleKeyCommand,
    _ref$keyBindingFn = _ref.keyBindingFn,
    keyBindingFn = _ref$keyBindingFn === void 0 ? function () {
      return 'do-nothing';
    } : _ref$keyBindingFn,
    _ref$handleReturn = _ref.handleReturn,
    handleReturn = _ref$handleReturn === void 0 ? function () {
      return NOT_HANDLED;
    } : _ref$handleReturn,
    _ref$inlineButtons = _ref.inlineButtons,
    inlineButtons = _ref$inlineButtons === void 0 ? [] : _ref$inlineButtons,
    _ref$isTextExist = _ref.isTextExist,
    isTextExist = _ref$isTextExist === void 0 ? false : _ref$isTextExist,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$onContentScroll = _ref.onContentScroll,
    onContentScroll = _ref$onContentScroll === void 0 ? _.noop : _ref$onContentScroll,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? _.noop : _ref$onSelect,
    _ref$onEditorDoubleCl = _ref.onEditorDoubleClick,
    onEditorDoubleClick = _ref$onEditorDoubleCl === void 0 ? _.noop : _ref$onEditorDoubleCl,
    _ref$fullSize = _ref.fullSize,
    fullSize = _ref$fullSize === void 0 ? false : _ref$fullSize;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(s.lessonTextContent, className, (_classNames = {}, _defineProperty(_classNames, s.fullWidth, fullWidth), _defineProperty(_classNames, s.noContent, !isTextExist), _defineProperty(_classNames, s.fullSize, fullSize), _classNames))
    // onTouchStart={this.onDoubleTap} // to disable edit toolbar on IOS
    ,
    onScroll: onContentScroll,
    onSelect: onSelect,
    id: "lesson-content",
    onDoubleClick: onEditorDoubleClick
  }, void 0, isTextExist && /*#__PURE__*/React.createElement(Editor, {
    ref: ref,
    showLinkEditToolbar: false,
    editorState: editorState,
    editorEnabled: editorEnabled,
    onChange: onEditorChange,
    handleKeyCommand: handleKeyCommand,
    keyBindingFn: keyBinding,
    handleReturn: handleReturn,
    handleDrop: function handleDrop() {
      return HANDLED;
    },
    sideButtons: [],
    blockButtons: [],
    inlineButtons: inlineButtons,
    rendererFn: customrenderer,
    spellCheck: false
  }), children);
});
LessonTextContent.propTypes = {
  editorState: PropTypes.object,
  // eslint-disable-line
  editorEnabled: PropTypes.bool,
  onEditorChange: PropTypes.func,
  handleKeyCommand: PropTypes.func,
  keyBinding: PropTypes.func.isRequired,
  handleReturn: PropTypes.func,
  inlineButtons: PropTypes.array,
  // eslint-disable-line
  isTextExist: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string.isRequired,
  onContentScroll: PropTypes.func,
  onSelect: PropTypes.func,
  onEditorDoubleClick: PropTypes.func,
  fullSize: PropTypes.bool,
  children: PropTypes.node.isRequired,
  keyBindingFn: PropTypes.func
};
export default withStyles(s)(LessonTextContent);